module.exports = __webpack_public_path__ + "static/img/1_4.ae01c6d0.jpg";